module.exports = __webpack_public_path__ + "static/women-in-tech.6f5e695b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/women-in-tech.jpg
// module id = 407
// module chunks = 168707334958949